import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

const RHFTextField = ({
  name,
  control,
  label,
  info,
  forceError,
  rules,
  normalize,
  format,
  onChange: customOnChange,
  onBlur: customOnBlur,
  placeholder,
  InputLabelProps,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({
      field: { onChange, onBlur, value, ref },
      fieldState: { error, invalid, isTouched }
    }) => {
      const displayValue = format ? format(value) : (value ?? '');

      const handleChange = e => {
        let val = e.target.value;
        if (normalize) {
          val = normalize(val, value);
        }
        onChange(val);
        if (customOnChange) {
          customOnChange(e, val, value, name);
        }
      };

      const handleBlur = e => {
        onBlur(e);
        if (customOnBlur) {
          customOnBlur(e, value, value, name);
        }
      };

      return (
        <TextField
          name={name}
          inputRef={ref}
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          label={label}
          placeholder={placeholder || label}
          InputLabelProps={{
            ...(placeholder ? { shrink: true } : {}),
            ...InputLabelProps
          }}
          error={((isTouched || forceError) && invalid) || !!error}
          helperText={(((isTouched || forceError) || !!error) && error?.message) || info}
          {...rest}
        />
      );
    }}
  />
);

export default RHFTextField;
